import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class If_block extends ASTBlock {
    constructor(color) {
        super(color, "if_block")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "message0": "%{BKY_CONTROLS_IF_MSG_IF} %1",
            "args0": [{
                "type": "input_value",
                "name": "IF0",
                "check": "Boolean"
            }],
            "message1": "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            "args1": [{
                "type": "input_statement",
                "name": "DO0"
            }],
            "previousStatement": null,
            "nextStatement": null,
            "helpUrl": "%{BKY_CONTROLS_IF_HELPURL}",
            "suppressPrefixSuffix": 1,
            "mutator": "controls_if_mutator",
            "extensions": [
                "controls_if_tooltip"
            ]
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}